import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import 'meta-pixel'; // Import the package without destructuring
export function AppRouter() {
  useEffect(() => {
    // Access fbq from the window object
    if (window.fbq) {
      // Initialize Facebook Pixel
      window.fbq('init', '123456789012345'); // Replace with your actual Facebook Pixel ID
      // Track page view on initial load
      window.fbq('track', 'PageView');
    }
  }, []);
  return <BrowserRouter data-id="element-3">
      <Routes data-id="element-4">
        <Route path="/" element={<App data-id="element-6" />} data-id="element-5" />
      </Routes>
    </BrowserRouter>;
}